module.exports = __webpack_public_path__ + "static/media/13.32d0b937.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/13.png
// module id = 794
// module chunks = 0